import React, { useState, useRef, useEffect } from "react";
import {
  TextField,
  IconButton,
  Typography,
  Box,
  InputAdornment,
} from "@mui/material";
import ProductComponentBox from "../NewProduct/components/ProductComponentBox";
import "./index.css";
import "../../index.css";
import searchIcon from "../../assets/design-revamp-product/product-icons/search-bar-icon.svg";
import Carousel from "react-multi-carousel-18";
import "react-multi-carousel-18/lib/styles.css";
import customLeftArrow from "../../assets/design-revamp-product/product-icons/leftArrow.svg";
import customRightArrow from "../../assets/design-revamp-product/product-icons/rightArrow.svg";
import { Link } from "react-router-dom";
const styles = {
  container: {
    margin: "0 auto",
    marginTop: "9px",
  },
  searchForm: {
    marginBottom: "20px",
    position: "relative",
  },
  resultsList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    position: "relative",
    marginTop: "30px",
  },
};

const FilterSearchProduct = ({ products = [], subgroups = [], year }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState(products);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("name");
  const [showSubgroups, setShowSubgroups] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const filterRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setIsFilterOpen(false);
        setShowSubgroups(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getSubgroupName = (subgroupId) => {
    const subgroup = subgroups.find((sg) => sg.id === subgroupId);
    return subgroup ? subgroup.name : "";
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSubmitted(true);
    const term = (searchTerm || "")?.toLowerCase().trim();

    if (term === "") {
      setSearchResults(products);
      return;
    }

    const filtered = products.filter((product) => {
      const name = (product?.name || "")?.toLowerCase();
      const productNum = (product?.product_num || "")?.toLowerCase();
      const subgroupName = getSubgroupName(product?.subgroup)?.toLowerCase();

      if (selectedFilter === "name") {
        return name.includes(term);
      } else if (selectedFilter === "product_num") {
        return productNum.includes(term);
      } else if (selectedFilter === "subgroup") {
        return subgroupName.includes(term);
      } else if (
        ["Type", "Size", "Surface", "System"].includes(selectedFilter)
      ) {
        return product?.variation_categories?.some(
          (vc) =>
            vc.name === selectedFilter ||
            vc.values?.some((v) => v.value.toLowerCase().includes(term))
        );
      }

      return false;
    });

    setSearchResults(filtered);
  };

  useEffect(() => {
    if (submitted) {
      const timer = setTimeout(() => setSubmitted(false), 500);
      return () => clearTimeout(timer);
    }
  }, [searchResults, submitted]);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1600 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 1600, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 2,
    },
  };

  const CustomLeftArrow = (props) => (
    <img
      src={customLeftArrow}
      alt="Left Arrow Carousel"
      width={50}
      height={50}
      style={{
        position: "absolute",
        top: "50%",
        left: "-8px",
        transform: "translateY(-50%)",
        cursor: "pointer",
        opacity: 0.8,
      }}
      {...props}
    />
  );

  const CustomRightArrow = (props) => (
    <img
      src={customRightArrow}
      alt="Right Arrow Carousel"
      width={50}
      height={50}
      style={{
        position: "absolute",
        top: "50%",
        right: "10px",
        transform: "translateY(-50%)",
        cursor: "pointer",
        opacity: 0.8,
      }}
      {...props}
    />
  );

  const handleFilterSelect = (filter) => {
    if (filter === "subgroup") {
      setShowSubgroups(true);
    } else {
      setSelectedFilter(filter);
      setIsFilterOpen(false);
      setShowSubgroups(false);
    }
  };

  const handleSubgroupSelect = (subgroupName) => {
    setSelectedFilter("subgroup");
    setSearchTerm(subgroupName);
    setIsFilterOpen(false);
    setShowSubgroups(false);
  };

  return (
    <Box sx={styles.container}>
      <div className="search-container search-bar-product-bg">
        <div
          className={`filter-dropdown ${
            isFilterOpen ? "open" : ""
          } search-bar-dropdown-bg`}
          ref={filterRef}
          style={{ position: "relative" }}
        >
          <button
            className="filter-button"
            onClick={() => setIsFilterOpen(!isFilterOpen)}
            type="button"
          >
            {selectedFilter === "product_num"
              ? "Product Number"
              : selectedFilter === "subgroup"
              ? "Subgroup"
              : selectedFilter.charAt(0).toUpperCase() +
                selectedFilter.slice(1)}
            <span className={`filter-arrow ${isFilterOpen ? "rotate" : ""}`}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#664650"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </span>
          </button>

          {isFilterOpen && (
            <div
              className="filter-options"
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                width: "100%",
                zIndex: 1000,
              }}
            >
              <div
                className="filter-option"
                onClick={() => handleFilterSelect("name")}
              >
                Name
              </div>
              <div
                className="filter-option"
                onClick={() => handleFilterSelect("product_num")}
              >
                Product Number
              </div>
              <div
                className="filter-option"
                onClick={() => handleFilterSelect("subgroup")}
              >
                Subgroup
                {showSubgroups && (
                  <div className="subgroup-options">
                    {subgroups.map((subgroup) => (
                      <div
                        key={subgroup.id}
                        className="filter-option-subgroup"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSubgroupSelect(subgroup.name);
                        }}
                      >
                        {subgroup.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div
                className="filter-option"
                onClick={() => handleFilterSelect("Type")}
              >
                Type
              </div>
              <div
                className="filter-option"
                onClick={() => handleFilterSelect("Size")}
              >
                Size
              </div>
              <div
                className="filter-option"
                onClick={() => handleFilterSelect("Surface")}
              >
                Surface
              </div>
              <div
                className="filter-option"
                onClick={() => handleFilterSelect("System")}
              >
                System
              </div>
            </div>
          )}
        </div>

        <Box className="search-field-product">
          <form onSubmit={handleSearch}>
            <TextField
              fullWidth
              variant="standard"
              placeholder={`Search by ${selectedFilter}...`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{
                width: "100%",
                "& .MuiInput-underline:before": {
                  borderBottom: "none",
                },
                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                  borderBottom: "none",
                },
                "& .MuiInput-underline:after": {
                  borderBottom: "none",
                },
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton type="submit" edge="end">
                      <img
                        src={searchIcon}
                        alt="Search bar icon"
                        width={20}
                        height={20}
                      />
                    </IconButton>
                  </InputAdornment>
                ),
                style: {
                  color: "#664650",
                  outline: "none",
                  border: "none",
                  width: "100%",
                  height: "100%",
                  padding: "10px",
                },
              }}
            />
          </form>
        </Box>
      </div>

      <Box sx={styles.resultsList}>
        <div style={{ position: "absolute", top: "-12px", left: "20px" }}>
          <div className="search-results-bg">Search results</div>
        </div>
        <div
          className="mt-8 smooth-fade product__bubble "
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            position: "relative",
          }}
        >
          <Carousel
            responsive={responsive}
            infinite={false}
            keyBoardControl={true}
            customTransition="transform 300ms ease-in-out"
            containerClass="carousel-container"
            itemClass="carousel-item"
            customLeftArrow={<CustomLeftArrow />}
            customRightArrow={<CustomRightArrow />}
          >
            {searchResults.map((product, i) => (
              <Link
                key={i}
                className="nav-link"
                to={`/product/${product.id}?business=${product.business}&year=${year}`}
                onClick={(e) => e.target.tagName === "A" && e.preventDefault()}
              >
                <ProductComponentBox
                  key={product.id}
                  name={product?.name}
                  prodNum={product?.product_num}
                  variationValues={product?.variation_categories}
                  subgroup={getSubgroupName(product.subgroup)}
                  productId={product.id}
                />
              </Link>
            ))}
          </Carousel>

          {searchResults.length === 0 && searchTerm && submitted && (
            <Typography sx={styles.noResults}>
              No products found matching "{searchTerm}"
            </Typography>
          )}
        </div>
      </Box>
    </Box>
  );
};

export default FilterSearchProduct;
